import { render, staticRenderFns } from "./DescuentoPlazo.vue?vue&type=template&id=2dfd30a0"
import script from "./DescuentoPlazo.vue?vue&type=script&lang=js"
export * from "./DescuentoPlazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports